import React from 'react';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/dynamic-accept-terms'));

export default function (dependencies) {
  const { language } = dependencies;
  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...props, ...dependencies });
  };
  return {
    html,
    validators: [
      function (state, globalState, config) {
        if (state.value === 'false') {
          return language['error-must-accept'];
        }

        return false;
      },
    ],
    config: {
      options: [
        {
          value: 'true',
          display: language['yes']
        },
        {
          value: 'false',
          display: language['no']
        }

      ]
    },
  };
}
